import { VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

import * as api from '../../../api';
import TextData from '../../../components/TextData';

interface AllergiesProps {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}

const Allergies = ({ field }: AllergiesProps) => {
  const { t } = useTranslation('review');

  const allergies = JSON.parse(field.value) as api.Allergy.PrevisitAllergy[];

  return (
    <VStack gap={16}>
      {allergies.map(({ name, reactions, severity }) => {
        const translatedReactions = (reactions || []).map((reaction) =>
          t(api.Allergy.reactionMap[reaction]),
        );
        const translatedSeverity = severity
          ? t(api.Allergy.severityMap[severity])
          : null;

        const label = [...translatedReactions, translatedSeverity]
          .filter(Boolean)
          .join(', ');

        return (
          <TextData
            key={label}
            label={label}
            value={t(
              api.Allergy.AllergyNameToStandardAllergyMap[
                (name as api.Allergy.AllergyName) || 'OTHER'
              ].displayName,
            )}
          />
        );
      })}
    </VStack>
  );
};

export default Allergies;
